import { ACCESS_MANAGEMENT_TABS } from "components/utils/accessManagement";
import { computeTotalGroupsCount } from "components/utils/policy";
import theme from "components/utils/theme"
import PeopleIcon from "static/svgs/People"
import RegisterSettingsIcon from "static/svgs/RegisterSettings";
import UsersIcon from "static/svgs/users";


export const getPortalManagementResources = ({ groups, users, policies }) => {
    return [
        {
            count: computeTotalGroupsCount(groups),
            label: "User Group",
            icon: <PeopleIcon />,
            className: "user-group",
            tab: ACCESS_MANAGEMENT_TABS.GROUPS,
        },
        {
            count: users.length,
            label: "Users",
            icon: <UsersIcon />,
            className: "users",
            tab: ACCESS_MANAGEMENT_TABS.USER,
        },
        {
            count: policies?.length,
            label: "Roles",
            icon: <RegisterSettingsIcon />,
            className: "roles",
            tab: ACCESS_MANAGEMENT_TABS.POLICIES,
        },

    ]
}

export const portalCardColors = [
    theme.palette.primary.light,
    theme.palette.secondary.main,
    theme.palette.primary.main,
    theme.palette.info.main,
];

export const getPortalNavItems = ({ areGroupsAllowed, areUsersAllowed, areRolesAllowed }) => {
    return [
        areGroupsAllowed ? { label: ACCESS_MANAGEMENT_TABS.GROUPS } : null,
        areUsersAllowed ? { label: ACCESS_MANAGEMENT_TABS.USER } : null,
        areRolesAllowed ? { label: ACCESS_MANAGEMENT_TABS.ROLES } : null,
    ].filter(Boolean);
}

export const USER_PERMISSIONS = {
    VIEW_DEVICE_LOCATION: "VIEW_DEVICE_LOCATION",
    VIEW_SYSTEM_DETAILS: "VIEW_SYSTEM_DETAILS",
    VIEW_NETWORK_INTERFACES: "VIEW_NETWORK_INTERFACES",
    VIEW_NETWORK_PORTS: "VIEW_NETWORK_PORTS",
    KILL_PORT: "KILL_PORT",
    VIEW_RUNNING_PROCESSES: "VIEW_RUNNING_PROCESSES",
    KILL_PROCESS: "KILL_PROCESS",
    VIEW_INSTALLED_APPLICATIONS: "VIEW_INSTALLED_APPLICATIONS",
    UNINSTALL_APPLICATION: "UNINSTALL_APPLICATION",
    VIEW_FILE_INTEGRITY_MANAGEMENT: "VIEW_FILE_INTEGRITY_MANAGEMENT",
    VIEW_ALERTS: "VIEW_ALERTS",
    VIEW_ANOMALIES: "VIEW_ANOMALIES",
    VIEW_DEVICE_USERS: "VIEW_DEVICE_USERS",
    ADD_DEVICE_USER: "ADD_DEVICE_USER",
    DELETE_DEVICE: "DELETE_DEVICE",
    VIEW_DEVICE_DETAILS: "VIEW_DEVICE_DETAILS",
    ADD_NETWORK: "ADD_NETWORK",
    DELETE_NETWORK: "DELETE_NETWORK",
    VIEW_NETWORK_DETAILS: "VIEW_NETWORK_DETAILS",
    UPDATE_NETWORK_CREDENTIALS: "UPDATE_NETWORK_CREDENTIALS",
    ALLOW_NETWORK_RESCAN: "ALLOW_NETWORK_RESCAN",
    VIEW_PORTAL_GROUPS: "VIEW_PORTAL_GROUPS",
    CREATE_PORTAL_GROUPS: "CREATE_PORTAL_GROUPS",
    DELETE_PORTAL_GROUPS: "DELETE_PORTAL_GROUPS",
    EDIT_PORTAL_GROUPS: "EDIT_PORTAL_GROUPS",
    VIEW_PORTAL_USERS: "VIEW_PORTAL_USERS",
    INVITE_PORTAL_USERS: "INVITE_PORTAL_USERS",
    ASSIGN_PORTAL_USER_TO_GROUP: "ASSIGN_PORTAL_USER_TO_GROUP",
    VIEW_ROLES: "VIEW_ROLES",
    CREATE_ROLES: "CREATE_ROLES",
    DELETE_ROLES: "DELETE_ROLES",
    ASSIGN_ROLE_TO_GROUP: "ASSIGN_ROLE_TO_GROUP",
    VIEW_ASSET_GROUPS: "VIEW_ASSET_GROUPS",
    CREATE_ASSET_GROUPS: "CREATE_ASSET_GROUPS",
    DELETE_ASSET_GROUPS: "DELETE_ASSET_GROUPS",
    EDIT_ASSET_GROUPS: "EDIT_ASSET_GROUPS",
    VIEW_EMPLOYEES: "VIEW_EMPLOYEES",
    ADD_EMPLOYEES: "ADD_EMPLOYEES",
    DELETE_EMPLOYEES: "DELETE_EMPLOYEES",
    ASSIGN_EMPLOYEES_TO_GROUP: "ASSIGN_EMPLOYEES_TO_GROUP",
    ASSIGN_DEVICE_TO_GROUP: "ASSIGN_DEVICE_TO_GROUP",
    VIEW_ALERT_POLICY: "VIEW_ALERT_POLICY",
    ADD_ALERT_POLICY: "ADD_ALERT_POLICY",
    REMOVE_ALERT_POLICY: "REMOVE_ALERT_POLICY",
    ASSIGN_ALERT_POLICY_TO_GROUP: "ASSIGN_ALERT_POLICY_TO_GROUP",
    NOTIFICATIONS: "NOTIFICATIONS",
    VIEW_AUTHENTICATION: "VIEW_AUTHENTICATION",
    UPDATE_AUTHENTICATION: "UPDATE_AUTHENTICATION",
    VIEW_BILLING: "VIEW_BILLING",
    CANCEL_MEMBERSHIP: "CANCEL_MEMBERSHIP",
    ACCESS_SINGLE_DEVICE_CONSOLE: "ACCESS_SINGLE_DEVICE_CONSOLE",
    ACCESS_MULTI_DEVICE_CONSOLE: "ACCESS_MULTI_DEVICE_CONSOLE",
    ALLOW_EXPORT_TABLES: "ALLOW_EXPORT_TABLES",
    ENFORCE_2FA: "ENFORCE_2FA",
    ENROLL_DEVICE: "ENROLL_DEVICE",
    VIEW_PORTAL_MANAGEMENT: "VIEW_PORTAL_MANAGEMENT",
    VIEW_ASSET_MANAGEMENT: "VIEW_ASSET_MANAGEMENT",

};

